module.exports = __webpack_public_path__ + "static/media/backgroundLight.efd804ed.png";